import { render, staticRenderFns } from "./NotificationCountSingle.vue?vue&type=template&id=9a8f37a8&scoped=true&lang=pug&"
import script from "./NotificationCountSingle.vue?vue&type=script&lang=js&"
export * from "./NotificationCountSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8f37a8",
  null
  
)

export default component.exports